import React, { useEffect } from 'react';

import SettingsIcon from '@mui/icons-material/Settings';
import {
    Box,
    IconButton,
    Tooltip,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from './actions';
import TableSettingsModal from './components/TableSettingsModal';
import * as selectors from './selectors';

const Container = ({
    columnsConfig,
    fetchTableSettings,
    handleClickOpenModal,
    isOpenModal,
    tableKey,
    tableSettings,
}) => {
    const { t } = useTranslation();

    useEffect(() => {
        if (tableKey) fetchTableSettings(tableKey, columnsConfig);
    }, [tableKey]);

    return (
        <>
            <Box display="flex" alignItems="center" gap={1}>
                <Typography fontWeight="bold" variant="body2">
                    {t('Column', { count: 2 })}
                </Typography>
                <Tooltip placement="top" title={t('Set up')}>
                    <IconButton onClick={() => handleClickOpenModal(true)}>
                        <SettingsIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            </Box>

            <TableSettingsModal
                columnsConfig={columnsConfig}
                fetchTableSettings={fetchTableSettings}
                handleClickCloseModal={() => handleClickOpenModal(false)}
                isOpenModal={isOpenModal}
                tableKey={tableKey}
                tableSettings={tableSettings}
            />
        </>
    );
};

Container.propTypes = {
    columnsConfig: PropTypes.object,
    fetchTableSettings: PropTypes.func,
    handleClickOpenModal: PropTypes.func,
    isOpenModal: PropTypes.bool,
    tableKey: PropTypes.string,
    tableSettings: PropTypes.array,
};

const mapStateToProps = createStructuredSelector({
    isOpenModal: selectors.getIsOpenModal,
    tableSettings: selectors.getTableSettingsData,
});

const mapDispatchToProps = (dispatch) => ({
    fetchTableSettings: (tableKey, columnsConfig) =>
        dispatch(actions.fetchTableSettings(tableKey, columnsConfig)),
    handleClickOpenModal: (value) => dispatch(actions.setIsOpenModal(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Container);
